import workspace from "./workspace";
import { useStore } from "@/store";

export const getWorkspaceStats = async () => {
  try {
    const userOrg = useStore.userOrg();
    const params =  { org_name: userOrg };
    
    const response = await workspace.get(`/dashboard-stats/`, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching stats:", error);
    throw error;
  }
};